import {Trans} from '@lingui/macro';
import _ from 'lodash';
import React from 'react';

import {buildTeammateDisplayName} from '../../../../../src/helpers/modelHelpers';
import {buildContactDisplayName} from '../../../../../src/helpers/models/contactHelpers';
import {CommentModel} from '../../../../../src/models/api/commentModel';
import {TeammateModel} from '../../../../../src/models/api/teammateModel';
import {VisualRecipientModel} from '../../../../../src/models/api/visualRecipientModel';

/*
 * Helpers.
 */

export function renderRecipientReference(
  from: TeammateModel,
  recipient: VisualRecipientModel,
  isHighlight: boolean,
  userId?: number,
) {
  const isAuthor = from.id === userId;
  const recipientName = buildContactDisplayName(recipient);

  if (isAuthor && !isHighlight) {
    return <Trans id="timeline-comment-selfquote">You quoted {recipientName}</Trans>;
  }

  const teammateName = buildTeammateDisplayName(from);

  if (!isAuthor && !isHighlight) {
    return (
      <Trans id="timeline-comment-quote">
        {teammateName} quoted {recipientName}
      </Trans>
    );
  }

  if (isAuthor && isHighlight) {
    return <Trans id="timeline-comment-selfhighlight">You highlighted</Trans>;
  }

  return <Trans id="timeline-comment-highlight">{teammateName} highlighted</Trans>;
}

export function renderSentReference(from: TeammateModel, to: TeammateModel, userId: number) {
  const isReferencer = from.id === userId;
  const isReferencee = to.id === userId;
  const fromTeammateName = buildTeammateDisplayName(from);
  const toTeammateName = buildTeammateDisplayName(to);

  if (isReferencer && isReferencee) {
    return <Trans id="timeline-comment-selfreference">You replied to yourself</Trans>;
  }

  if (isReferencee) {
    return <Trans id="timeline-comment-referencee">{fromTeammateName} replied to you</Trans>;
  }

  if (isReferencer) {
    return <Trans id="timeline-comment-referencer">You replied to {toTeammateName}</Trans>;
  }

  return (
    <Trans id="timeline-comment-reference">
      {fromTeammateName} replied to {toTeammateName}
    </Trans>
  );
}

export function renderDraftReference(to: TeammateModel, userId: number) {
  if (to.id === userId) {
    return <Trans id="composer-comment-selfreference">Replying to yourself</Trans>;
  }

  return <Trans id="composer-comment-reference">Replying to {buildTeammateDisplayName(to)}</Trans>;
}

export function renderContentPreview(comment: CommentModel) {
  const hasText = comment.text.length > 0;
  if (hasText) {
    return comment.text;
  }

  return _(comment.attachments)
    .map((a) => `[${a.name}]`)
    .join(' ');
}
